import http from 'conversations-http/clients/http';
import { indexGenericChannelsWithCapabilitiesById } from '../operators/indexGenericChannelsWithCapabilitiesById';
export const fetchGenericChannelsWithCapabilities = () => {
  return http.get(`conversations-channels/v1/generic-channels/with-capabilities`).then(indexGenericChannelsWithCapabilitiesById);
};